import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes, css } from 'styled-components';

const glowAnimation = keyframes`
   0% {
     box-shadow: 0 0 0px 0 rgba(255, 255, 255, 0.2);
   }
   50% {
     box-shadow: 0 0 3px 0 rgba(255, 255, 255, 0.6);
   }
   100% {
     box-shadow: 0 0 0px 0 rgba(255, 255, 255, 0.2);
   }
 `;

const MainContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  `;
  
  const StyledButton = styled.button`
  background-color: ${({ theme }) => theme.colors.magenta};
  color: ${(props) => props.theme.colors.white};
  width: 100%;
  max-width: 1170px;
  padding: 12px 15px;
  margin: 20px auto 0 auto;
  border: none;
  font-size: 20px;
  font-family: ${(props) => props.theme.fonts.content};
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  transition: all 1s ease;
  box-sizing: border-box;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, .5);
  cursor: pointer;
  animation: ${glowAnimation} 1.8s ease-in-out infinite;
`;

const Button = ({ text }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/contact');
  };

  return (
    <MainContainer>
      <StyledButton onClick={handleClick}>{text}</StyledButton>
    </MainContainer>
  );
};


export default Button;